import { useCallback, useEffect, useState } from 'react';
import { nodeImportService } from '../services/nodeImport.service';
import type { ImportedNodeType, ImportStatusResponse } from '../types/nodeImport.types';

export function useNodeImport() {
  const [nodes, setNodes] = useState<ImportedNodeType[]>([]);
  const [count, setCount] = useState(0);
  const [status, setStatus] = useState<ImportStatusResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async (params?: {
    page?: number;
    page_size?: number;
    search?: string;
    category?: string;
    is_active?: boolean;
    has_errors?: boolean;
  }) => {
    setLoading(true);
    setError(null);
    try {
      const [nodesResp, statusResp] = await Promise.all([
        nodeImportService.getImportedNodes(params),
        nodeImportService.getStatus(),
      ]);
      setNodes(nodesResp.results || []);
      setCount(nodesResp.count ?? 0);
      setStatus(statusResp);
    } catch (e: any) {
      setError(e?.message || 'Failed to load imported nodes');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { nodes, count, status, loading, error, refresh };
}


